import { Button, Card, CardContent, Stack, Typography } from "@mui/material";

const PaymentMethodNotFound = () => {

    return <>
        <Card sx={{marginY: 3}}>
            <CardContent>
                <Typography variant="h6" align="center">Sorry</Typography>
                <Typography align="center">Payment Method Not Found</Typography>
            </CardContent>
        </Card>
        <Stack direction={"row"} alignItems={"center"} sx={{marginTop: 1, marginBottom: 0.5}}>
            <Typography variant="caption">Payment Method : </Typography>
        </Stack>
        <Button variant="contained" fullWidth disabled>Pay Now</Button>
    </>
}

export default PaymentMethodNotFound;